import { useQuery } from '@apollo/client';

import { GET_CURRENT_STATE } from '@pass-frontend/common/data-access';
import {
  AuthStatus,
  CurrentState,
} from '@pass-frontend/data-access/common/edge';

export const useCurrentState = () => {
  const { loading, data, error, startPolling, stopPolling } = useQuery<{
    currentState: CurrentState;
  }>(GET_CURRENT_STATE, {
    fetchPolicy: 'network-only',
  });

  const { currentState } = data || {};

  const isQualifiedUser = currentState?.authStatus === AuthStatus.qualified;
  const isUnverifiedUser = currentState?.authStatus === AuthStatus.unverified;
  const isUserAuthenticated = currentState?.isHsidSessionValid || false;
  const isAuthenticationInProgress = loading && !isQualifiedUser;
  const isImpersonatedView = currentState?.isImpersonatedView;
  return {
    currentState,
    error,
    loading,
    startPolling,
    stopPolling,
    isQualifiedUser,
    isUnverifiedUser,
    isUserAuthenticated,
    isAuthenticationInProgress,
    isImpersonatedView,
  };
};
